// free products
const transactionCodeFreeBusinessProfile = [
    'I059',
    'I060',
    'I061',
    'I062',
    'I063',
    'I064',
    'I065',
    'I066',
    'I067',
];
const transactionCodeFreeCertificate = ['I068'];
const transactionCodeFreeRegister = ['I048', 'I049', 'I050', 'I051', 'I052'];
const freePrdDnlTxnTrackingIdMappings = {
    FREE_BUSINESS_PROFILE: 'br2sbizfile-5745',
    FREE_CERTIFICATE: 'br2sbizfile-5746',
    FREE_REGISTERS: 'br2sbizfile-5747',
};
export function getFreePrdDnlTxn(transactionCode) {
    if (transactionCodeFreeBusinessProfile.includes(transactionCode)) {
        return {
            trackingId: freePrdDnlTxnTrackingIdMappings.FREE_BUSINESS_PROFILE,
            transactionName: 'Free Business Profile',
        };
    }
    if (transactionCodeFreeCertificate.includes(transactionCode)) {
        return {
            trackingId: freePrdDnlTxnTrackingIdMappings.FREE_CERTIFICATE,
            transactionName: 'Free Certificate',
        };
    }
    if (transactionCodeFreeRegister.includes(transactionCode)) {
        return {
            trackingId: freePrdDnlTxnTrackingIdMappings.FREE_REGISTERS,
            transactionName: 'Free Registers',
        };
    }
    return { trackingId: '', transactionName: '' };
}
// buy information products
export const businessProfileCodes = ['I001', 'I003', 'I014', 'I023', 'I025'];
const corporateComplianceAndFinancialProfileCodes = ['I027'];
export const certificateCodes = [
    'I005',
    'I030',
    'I031',
    'I032',
    'I033',
    'I034',
    'I035',
    'I037',
    'I038',
    'I039',
    'I040',
    'I041',
    'I042',
    'I043',
    'I045',
    'I046',
    'I047',
    'I072',
    'I073',
];
const registerCodes = ['I006', 'I048', 'I049', 'I050', 'I051', 'I052'];
export const peopleProfileCodes = ['I007'];
export const extractCodes = ['X001', 'X005', 'X007', 'X008'];
const buyInformationPrdTrackingMappings = {
    BUSINESS_PROFILE: 'BizFile-5836',
    CORPORATE_COMPLIANCE_AND_FINANCIAL_PROFILE: 'BizFile-5837',
    CERTIFICATES: 'BizFile-5838',
    REGISTERS: 'BizFile-5839',
    PEOPLE_PROFILE: 'BizFile-5840',
    EXTRACTS: 'BizFile-5841',
};
export function getInformationProductTxn(transactionCode) {
    if (businessProfileCodes.includes(transactionCode)) {
        return {
            trackingId: buyInformationPrdTrackingMappings.BUSINESS_PROFILE,
            transactionName: 'Business Profile',
        };
    }
    if (corporateComplianceAndFinancialProfileCodes.includes(transactionCode)) {
        return {
            trackingId: buyInformationPrdTrackingMappings.CORPORATE_COMPLIANCE_AND_FINANCIAL_PROFILE,
            transactionName: 'Corporate Compliance and Financial Profile',
        };
    }
    if (certificateCodes.includes(transactionCode)) {
        return {
            trackingId: buyInformationPrdTrackingMappings.CERTIFICATES,
            transactionName: 'Certificates',
        };
    }
    if (registerCodes.includes(transactionCode)) {
        return {
            trackingId: buyInformationPrdTrackingMappings.REGISTERS,
            transactionName: 'Registers',
        };
    }
    if (peopleProfileCodes.includes(transactionCode)) {
        return {
            trackingId: buyInformationPrdTrackingMappings.PEOPLE_PROFILE,
            transactionName: 'People Profile',
        };
    }
    if (extractCodes.includes(transactionCode)) {
        return {
            trackingId: buyInformationPrdTrackingMappings.EXTRACTS,
            transactionName: 'Extracts',
        };
    }
    return {
        trackingId: '',
        transactionName: '',
    };
}
// federated search
export const federatedSearchTrackingMappings = {
    trackingId: 'br2sbizfile-5748',
    transactionName: 'Federated search',
};
